module.exports = __webpack_public_path__ + "static/img/5.c2d4ffe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/sp/5.png
// module id = XPlr
// module chunks = 0